import React from "react";
import { Tag, Typography } from "antd";
import {
  PlusCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  SwapOutlined,
  UserOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { PresetColorType } from "antd/lib/_util/colors";

interface Props {
  action: string;
}

export const HistoryAction: React.FC<Props> = ({ action }) => {
  // Map action to Spanish text
  const actionText =
    {
      created: "Creado",
      updated: "Actualizado",
      deleted: "Eliminado",
      status_changed: "Cambio de Estatus",
      assigned: "Asignado",
      uploaded: "Cargado",
    }[action] || action;

  // Get icon based on action
  const getActionIcon = () => {
    switch (action) {
      case "created":
        return <PlusCircleOutlined />;
      case "updated":
        return <EditOutlined />;
      case "deleted":
        return <DeleteOutlined />;
      case "status_changed":
        return <SwapOutlined />;
      case "assigned":
        return <UserOutlined />;
      case "uploaded":
        return <UploadOutlined />;
      default:
        return <EditOutlined />;
    }
  };

  // Get color based on action
  const getActionColor = ():
    | PresetColorType
    | "default"
    | "error"
    | "processing"
    | "success"
    | "warning" => {
    switch (action) {
      case "created":
        return "success";
      case "updated":
        return "processing";
      case "deleted":
        return "error";
      case "status_changed":
        return "warning";
      case "assigned":
        return "purple";
      case "uploaded":
        return "cyan";
      default:
        return "default";
    }
  };

  const actionIcon = getActionIcon();
  const actionColor = getActionColor();

  return (
    <Typography.Text className="font-medium my-1">
      Acción:{" "}
      <Tag color={actionColor} icon={actionIcon}>
        {actionText}
      </Tag>
    </Typography.Text>
  );
};
